import React from 'react';
import './HeaderPolicy.scss';

const HeaderPolicy = (props) => {
    const { title } = props;

    const closeBtnClick = () => {
        window.history.back();
    };

    return (
        <div className="header policy">
            <div className="header-container">
                <div className="header-title">
                    <span>{ title }</span>
                </div>
                <button className="header-close" onClick={closeBtnClick}>
                    <span className="ic-close"></span>
                </button>
            </div>
        </div>
    )
}

export default HeaderPolicy;
